module.exports = __webpack_public_path__ + "ec0a2ad08b8451c19dfebd58ddbdea75.MP3";